import isEmpty from 'lodash/isEmpty';

export default function ignoreInstagramAutofillCallbackError(event) {
    if (isEmpty(event?.exception?.values)) return event;

    const autofillError = event.exception.values.some(
        (value) =>
            value?.type === 'ReferenceError' &&
            value?.value === `Can't find variable: _AutofillCallbackHandler`,
    );

    if (!autofillError) return event;

    const isInstagram =
        !isEmpty(event.request?.headers?.['User-Agent']) &&
        event.request.headers['User-Agent'].includes('Instagram');

    if (!isInstagram) return event;

    return null;
}
